(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sub-categories"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const swiperSubCollection = document.querySelector('.swiper-subcategories');
  
  if (swiperSubCollection) {
    // Check if it's the pill variant
    const isPillStyle = swiperSubCollection.classList.contains('swiper-subcategories--pill');

    // Define base options
    let swiperOptions = {
      direction: 'horizontal',
      spaceBetween: 15,
      grabCursor: true,
      watchSlidesVisibility: true,
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      }
    };

    if (isPillStyle) {
      // --- PILL STYLE CONFIGURATION ---
      swiperOptions.slidesPerView = 'auto';
      swiperOptions.slidesPerGroup = 1;
    } else {
      // --- STANDARD GRID CONFIGURATION ---
      swiperOptions.slidesPerView = 2.5;
      swiperOptions.slidesPerGroup = 1;
      swiperOptions.breakpoints = {
        420: { slidesPerView: 3.5, slidesPerGroup: 3.5 },
        580: { slidesPerView: 4.5, slidesPerGroup: 4.5 },
        759: { slidesPerView: 5.5, slidesPerGroup: 5.5 },
        1050: { slidesPerView: 6, slidesPerGroup: 6 }
      };
    }

    // Initialize
    new Swiper(swiperSubCollection, swiperOptions);
  }
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sub-collections"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
  const swiperSubCollection = document.querySelector('.swiper-subcollection');
  if (swiperSubCollection) {
    const swiper = new Swiper(swiperSubCollection, {
      direction: 'horizontal',
      slidesPerGroup: 1,  
      slidesPerView: 2,
      spaceBetween: 15,
      grabCursor: true,
      watchSlidesVisibility: true,
      freeMode: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        420: {
          slidesPerView: 3,
          slidesPerGroup: 3
        },
        580: {
          slidesPerView: 4,
          slidesPerGroup: 4
        },
        959: {
          slidesPerView: 5,
          slidesPerGroup: 5
        },
        1050: {
          slidesPerView: 6,
          slidesPerGroup: 6
        }
      }
    });
  }
});
  } catch(e) { console.error(e); }
})();

})();
